export interface IMemberDepiction {
  attribution: string
  imageUrl: string
}
